import DOMPurify from "dompurify";
import { Icon } from "./Icons";

const fullDate = new Intl.DateTimeFormat("ru-RU", { dateStyle: "long", timeStyle: "short" });

export default function EmailView({ email, loading, onBack, onDelete, onDownload }) {
  if (loading || !email) return <section className="mailPanel stateMessage"><span className="spinner" />Открываем письмо</section>;

  const safeHtml = email.htmlBody
    ? DOMPurify.sanitize(email.htmlBody, {
        FORBID_TAGS: ["script", "style", "form", "iframe", "object", "embed"],
        FORBID_ATTR: ["srcset", "onerror", "onload"],
      })
    : "";
  const iframeDocument = safeHtml
    ? `<!doctype html><html><head><meta charset="utf-8"><base target="_blank"><style>body{font:15px/1.6 system-ui,sans-serif;color:#dce2ef;background:#111722;margin:0;padding:24px;overflow-wrap:anywhere}a{color:#73a7ff}img{max-width:100%;height:auto}pre{white-space:pre-wrap}</style></head><body>${safeHtml}</body></html>`
    : "";

  return (
    <section className="mailPanel emailView">
      <header className="viewToolbar">
        <button className="textButton" onClick={onBack}><Icon name="back" /> Назад</button>
        <button className="dangerButton" onClick={() => onDelete(email.id)}><Icon name="trash" /> Удалить</button>
      </header>
      <article className="messageArticle">
        <div className="messageTitle">{email.isTemp && <span className="tag">TEMP</span>}<h1>{email.subject}</h1></div>
        <div className="messageSender">
          <span className="senderAvatar large">{(email.senderName || email.sender).charAt(0).toUpperCase()}</span>
          <div><strong>{email.senderName || email.sender}</strong><span>{email.sender} → {email.recipient}</span></div>
          <time>{fullDate.format(new Date(email.receivedAt))}</time>
        </div>
        {email.attachments?.length > 0 && (
          <div className="attachments">
            {email.attachments.map((file) => (
              <button key={file.id} onClick={() => onDownload(file)}>
                <Icon name="paperclip" /><span><strong>{file.filename}</strong><small>{formatBytes(file.size)}</small></span><Icon name="download" />
              </button>
            ))}
          </div>
        )}
        {iframeDocument ? (
          <iframe className="emailFrame" title="Содержимое письма" sandbox="allow-popups allow-popups-to-escape-sandbox" srcDoc={iframeDocument} />
        ) : (
          <pre className="textBody">{email.textBody || "Письмо не содержит текста."}</pre>
        )}
      </article>
    </section>
  );
}

function formatBytes(bytes) {
  if (bytes < 1024) return `${bytes} Б`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} КБ`;
  return `${(bytes / 1024 / 1024).toFixed(1)} МБ`;
}
